import $ from 'jquery';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.en-GB.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min.js';

class BsDatePicker {
  constructor() {
    // this.themeData = wpSaxData ?: null;
    this.global = wpSaxData;
    // console.log(this.global);
    // console.log('bootstrap-datepicker');
    this.bookingFormDatepicker();
    this.contactFormDatepicker();
  }

  bookingFormDatepicker() {
    let currentLang = this.global.current_lang;
    if ($('#wpsax-booking-bar').length > 0) {
      if ($().datepicker) {

        // contact page datepicker
        $('#wpsax-booking-bar').each(function () {
          var bookingFormPeriod = $(this);
          $("input.booking-range", bookingFormPeriod).attr("autocomplete", "off");

          if (bookingFormPeriod.data("dateStartDate")) {
            startDate = bookingFormPeriod.data("dateStartDate");
          } else {
            var startDate = "0d";
          }

          bookingFormPeriod.datepicker({
            startDate: startDate,
            format: "dd/mm/yyyy",
            inputs: $(".booking-range", bookingFormPeriod),
            todayHighlight: true,
            todayBtn: "linked",
            daysOfWeekHighlighted: "0",
            zIndexOffset: 9999,
            orientation: "bottom",
            autoclose: true,
            language: currentLang,
            leftArrow: '<i class="fas fa-angle-left"></i>',
            rightArrow: '<i class="fas fa-angle-right"></i>'
          });

          var arrival = bookingFormPeriod.find("#booking-form--checkin"),
            departure = bookingFormPeriod.find("#booking-form--checkout");
          arrival.datepicker().on("changeDate", function (e) {
            $("#booking-form--checkout", bookingFormPeriod).trigger('focus');
          });

          // set departure to next day if dates are the same
          departure.datepicker().on("changeDate", function (e) {
            var arrival_date = arrival.datepicker("getUTCDate").getTime(),
              departure_date = departure.datepicker("getUTCDate").getTime();

            if (arrival_date == departure_date) {
              var next_day = new Date(departure_date).getTime() + 86400000;
              departure.datepicker("update", new Date(next_day));
            }
          });

          // .on('changeDate', function (e) {
          //     next = $('.departure input', bookingFormPeriod);
          //     if (next.length == 0) {
          //         next = $('.departure', bookingFormPeriod);
          //     }
          //     next.focus();
          // });

          // departure.datepicker() // you can continue to focus input of user
          //     .on('changeDate', function (e) {
          //         $('..next input selector..', bookingFormPeriod.parent()).focus();
          //     });

          // get click on .range fields and get its width
          $("input.booking-range", bookingFormPeriod).on('focus', function (e) {
            var inputWidth = e.target.offsetWidth;
            var bsdbDropDown = $(".datepicker-dropdown");
            bsdbDropDown.css('width', inputWidth + "px");
          });
        });
      } // END - #jQuery.bootstrap date picker END - #jQuery.bootstrap date picker
    }
  }

  contactFormDatepicker() {
    let currentLang = this.global.current_lang;
    if ($('#wpsax-contact-form').length > 0) {
      if ($().datepicker) {
        // contact page datepicker
        $("#wpsax-contact-form").each(function () {
          var period = $(this);

          $("input.range", period).attr("autocomplete", "off");

          if (period.data("dateStartDate")) {
            startDate = period.data("dateStartDate");
          } else {
            var startDate = "0d";
          }

          period.datepicker({
            startDate: startDate,
            format: "dd/mm/yyyy",
            inputs: $(".range", period),
            todayHighlight: true,
            todayBtn: "linked",
            daysOfWeekHighlighted: "0",
            zIndexOffset: 9999,
            orientation: "bottom",
            autoclose: true,
            language: currentLang,
          });

          var arrival = period.find("#contact-form--arrival"),
            departure = period.find("#contact-form--departure");
          arrival.datepicker().on("changeDate", function (e) {
            $("#contact-form--departure", period).trigger('focus');
          });

          // set departure to next day if dates are the same
          departure.datepicker().on("changeDate", function (e) {
            var arrival_date = arrival.datepicker("getUTCDate").getTime(),
              departure_date = departure.datepicker("getUTCDate").getTime();

            if (arrival_date == departure_date) {
              var next_day = new Date(departure_date).getTime() + 86400000;
              departure.datepicker("update", new Date(next_day));
            }
          });

          // .on('changeDate', function (e) {
          //     next = $('.departure input', period);
          //     if (next.length == 0) {
          //         next = $('.departure', period);
          //     }
          //     next.focus();
          // });

          // departure.datepicker() // you can continue to focus input of user
          //     .on('changeDate', function (e) {
          //         $('..next input selector..', period.parent()).focus();
          //     });

          // get click on .range fields and get its width
          $("input.range", period).on('focus', function (e) {
            var inputWidth = e.target.offsetWidth;
            var bsdpDropDown = $("#datepicker-dropdown");
            bsdpDropDown.css('width', inputWidth + "px");
          });
        });
      } // END - #jQuery.bootstrap date picker END - #jQuery.bootstrap date picker
    }
  }

  locale(lang) {
    if (lang == 'it') {
      // IT
      // console.log(lang);
      $.fn.datepicker.dates['it'] = {
        days: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        today: "Oggi",
        monthsTitle: "Mesi",
        clear: "Cancella",
        weekStart: 1,
        format: "dd/mm/yyyy"
      };
      // console.log($.fn.datepicker);
    } else if (lang == 'en') {
      // EN
      // console.log(lang);
      $.fn.datepicker.dates['en-GB'] = {
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        monthsTitle: "Months",
        clear: "Clear",
        weekStart: 1,
        format: "dd/mm/yyyy"
      }
    } else {
      // fallback EN
      $.fn.datepicker.dates['en-GB'] = {
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        monthsTitle: "Months",
        clear: "Clear",
        weekStart: 1,
        format: "dd/mm/yyyy"
      };
    }
  }
}

export default BsDatePicker;
